import { DatePipe } from '@angular/common'
import { Component, Input, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CustomPopoverOptions } from '@interfaces'
import {
	IonAlert,
	IonAvatar,
	IonBadge,
	IonContent,
	IonHeader,
	IonIcon,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonItem,
	IonLabel,
	IonList,
	IonLoading,
	IonSkeletonText,
	IonTitle,
	IonToolbar,
	PopoverController
} from '@ionic/angular/standalone'
import { TranslateModule } from '@ngx-translate/core'

@Component({
	selector: 'app-popover',
	standalone: true,
	templateUrl: './list-popover-message.component.html',
	styleUrls: ['./list-popover-message.component.scss'],
	imports: [
		IonIcon,
		IonHeader,
		IonToolbar,
		IonTitle,
		IonContent,
		IonLabel,
		IonBadge,
		IonAvatar,
		IonItem,
		IonList,
		IonLoading,
		IonInfiniteScroll,
		IonInfiniteScrollContent,
		IonSkeletonText,
		IonAlert,
		DatePipe,
		RouterModule,
		TranslateModule
	]
})
export class ListPopoverMessageComponent {
	private popoverController = inject(PopoverController)

	@Input() options: CustomPopoverOptions[] = []
	@Input() listed: boolean = true
	@Input() message: string

	executeAction(action: () => void) {
		action()
		this.popoverController.dismiss()
	}
}
